<p-dropdown
  [options]="sortings"
  [(ngModel)]="selectedSorting"
  (ngModelChange)="valueChange()"
  [placeholder]="'storedDocuments.sortingList.placeholderLabel' | translate"
  class="flex-1"
  styleClass="w-full">
  <ng-template
    pTemplate="item"
    let-sort>
    <div class="p-dropdown-item-container flex items-center px-3 py-2 gap-2 rounded-md">
      <span class="flex-initial text-sm text-black">{{ getTranslationUri(sort) | translate }}</span>
    </div>
  </ng-template>
  <ng-template
    pTemplate="selectedItem"
    let-sort>
    <span class="p-0">{{ getTranslationUri(sort) | translate }}</span>
  </ng-template>
</p-dropdown>
